module.exports = __webpack_public_path__ + "static/img/bg_neiye.7735b89b.jpg";